<!--
@Author: MIYONGLE
@Desc: 求职招聘 -- 衡阳慧用工做icp使用，页面废弃
@Date: 2021-04-16 18时
-->

<template>
  <div>
    <div class="min-width-pc">
      <div class="title-txt">社会招聘</div>

      <div class="setion-box">
        <div v-for="(item,index) in posiList" :key="index" 
          class="setion-box-item" @click="jumpPage(item)">
          <p>{{item.posiTitle}}</p>
          <p>{{item.range}}</p>
          <p>{{item.salary}}</p>
          <p>{{item.experience}}</p>
          <div>
            <span>{{ item.corporateName }}</span>
            <span>{{ item.phone }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";
import {POSILIST} from '../../service/businessConsts';
import {setLocal} from "../../filters/filters";

export default {
  name: "job-recruit",
  data() {
    return {
      source: '',
      sourceF: '',
      posiList: POSILIST
    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=zpqz_shzp' : '&pageFrom=zpqz_shzp';
    this.sourceF = this.source + "_f"; 
  },

  methods: {
    jumpPage(data){
      this.$router.push({
        path: '/jobRecruitDetail'
      })
      console.log(data)
      setLocal('posiInfo', data);
      // eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>
<style>
</style>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/产品服务/banner_product_2.png') no-repeat;
  background-size: cover;
  background-color: #111010;
  .text{
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 54px;
    text-align: left;
  }
  
}
.title-txt{
  margin-top: 181px;
}
.min-width-pc{
  .setion-box{
    display: flex;
    padding-bottom:230px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 41px;
    margin-top: 8px;
    flex-wrap:wrap;
    justify-content:space-between;
    align-content: flex-start;
    width: 998px;
    margin: 0 auto;
    margin-top: 38px;
    img{
      width: 100%;
      height: 576px;
    }
  }
}

.setion-box-item{
  width: 242px;
  height: 168px;
  background: #FFFFFF;
  box-shadow: 0px 20px 60px -10px rgba(25, 133, 255, 0.1);
  margin-bottom: 16px;
  padding: 16px 12px 20px  12px;
  box-sizing: border-box;
  p{
    text-align: left;
    cursor: pointer;
    &:nth-child(1){
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #100F0F;
      line-height: 22px;
      margin-bottom: 12px;
    }
    &:nth-child(2){
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
      margin-bottom: 6px;
    }

    &:nth-child(3){
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FF7D3D;
      line-height: 25px;
    }

    &:nth-child(4){
      width: 61px;
      height: 22px;
      border: 1px solid #CFCFCF;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9F9F9F;
      text-align: center;
      line-height: 22px;
      margin-top: 7px;
    }
  }
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    span {
      &:nth-child(1) {
        font-size: 12px;
        color: red;
      }
      &:nth-child(2) {
        font-size: 12px;
        color: #58c6ff;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/pc/jobRecruit.vue